import React, { useEffect } from "react";
import style from "./index.module.scss";
import Between from "@components/ui/Between";
import earth from "@imgs/earth.png";
import * as echarts from "echarts";
import "./china";
export default function Nodes({
  onClick,
}: {
  onClick: (value: string) => void;
}) {
  const data = [
    {
      name: "江苏激扬软件有限公司",
      node: "1节点",
      ip: "49.4.64.104",
      address: "南京市建邺区",
      value: 100,
    },
    {
      name: "省厅",
      node: "2节点",
      ip: "49.4.64.104",
      address:
        "南京市建邺区南京市建南京市建邺区南京市建南京市建邺区南京市建南京市建邺区南京市建南京市建邺区南京市建南京市建邺区南京市建南京市建邺区南京市建南京市建邺区南京市建",
      value: 100,
    },
    {
      name: "交通",
      node: "3节点",
      ip: "49.4.64.104",
      address: "南京市建邺区",
      value: 100,
    },
    {
      name: "江北新区",
      node: "4节点",
      ip: "49.4.64.104",
      address: "南京市建邺区",
      value: 100,
    },
  ];
  const geoCoordMap = {
    江苏激扬软件有限公司: [118.746745, 31.998113],
    省厅: [118.74, 32.09],
    交通: [118.79, 32.02],
    江北新区: [118.67, 32.08],
  };

  const convertData = function (data) {
    const res = [];
    for (let i = 0; i < data.length; i++) {
      const geoCoord = geoCoordMap[data[i].name];
      if (geoCoord) {
        res.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value),
          node: data[i].node,
          ip: data[i].ip,
          address: data[i].address,
        });
      }
    }
    return res;
  };
  useEffect(() => {
    // 基于准备好的dom，初始化echarts实例
    const myChart = echarts.init(
      document.getElementById("main") as HTMLElement
    );

    // 地图组件 参考文档 https://echarts3.ids7.com/gallery/editor.html?c=effectScatter-map
    const option = {
      backgroundColor: "#FFF",
      tooltip: {
        trigger: "item",
        formatter: function (a) {
          const d = a.data;
          return `<div><p style="color:#312B50">节点详情 (${d.node})</p>
          <div style="display: flex;align-items: center;">
              <div style="width:25px;height:25px; line-height: 25px;text-align: center;transform: scale(0.5);border-radius: 50%;border: 1px solid #58ADFE; color:#58ADFE; padding:5px;">CO</div>${d.name}</div>
          <div style="display: flex;align-items: center;"><span style="width:25px;height:25px; line-height: 25px;text-align: center;transform: scale(0.5);border-radius: 50%;border: 1px solid #58ADFE; color:#58ADFE; padding:5px;">IP</span>${d.ip}</div>
          <div style="display: flex;align-items: center;"><span style="width:25px;height:25px; line-height: 25px;text-align: center;transform: scale(0.5);border-radius: 50%;border: 1px solid #58ADFE; color:#58ADFE; padding:5px;">AD</span>${d.address}</div>
          <div style="display: flex;align-items: center;"><span style="width:25px;height:25px; line-height: 25px;text-align: center;transform: scale(0.5);border-radius: 50%;border: 1px solid #58ADFE; color:#58ADFE; padding:5px;">经</span>${d.value[0]}</div>
          <div style="display: flex;align-items: center;"><span style="width:25px;height:25px; line-height: 25px;text-align: center;transform: scale(0.5);border-radius: 50%;border: 1px solid #58ADFE; color:#58ADFE; padding:5px;">纬</span>${d.value[1]}</div></div>`;
        },
        extraCssText: "max-width:400px; white-space:normal",
      },
      geo: {
        map: "china",
        label: {
          emphasis: {
            show: false,
          },
        },
        roam: true,
        itemStyle: {
          normal: {
            areaColor: "#AFE0FF",
            borderColor: "#FFF",
          },
          emphasis: {
            areaColor: "#58ADFE",
          },
        },
      },
      series: [
        {
          name: "",
          type: "scatter",
          coordinateSystem: "geo",
          data: convertData(data),
          symbolSize: function (val) {
            return val[2] / 10;
          },
          label: {
            normal: {
              formatter: "{b}",
              position: "right",
              show: false,
            },
            emphasis: {
              show: true,
            },
          },
          itemStyle: {
            normal: {
              color: "#ddb926",
            },
          },
        },
        {
          name: "Top 5",
          type: "effectScatter",
          coordinateSystem: "geo",
          data: convertData(
            data
              .sort(function (a, b) {
                return b.value - a.value;
              })
              .slice(0, 100)
          ),
          symbolSize: function (val) {
            return val[2] / 10;
          },
          showEffectOn: "render",
          rippleEffect: {
            brushType: "stroke",
          },
          hoverAnimation: true,
          label: {
            normal: {
              formatter: "{b}",
              position: "right",
              show: true,
            },
          },
          itemStyle: {
            normal: {
              color: "#EE9B30",
              shadowBlur: 10,
              shadowColor: "#333",
            },
          },
          zlevel: 1,
        },
      ],
    };
    // @ts-ignore
    // 类型检测错误 ，参考文档 https://www.cnblogs.com/catherinezyr/p/10768399.html
    option && myChart.setOption(option);
  }, []);

  return (
    <div className={style.chart}>
      <div className={style.chart_title}>
        <Between
          title="区块链节点"
          content={
            <img width="30px" src={earth} onClick={() => onClick("earth")} />
          }
        />
      </div>
      <div style={{ height: "425px", width: "842px" }} id="main"></div>
    </div>
  );
}
